import { get } from 'lodash-es';
import { isAndroid } from './android';

export class AppConfig {
  static theme: string;

  static code: string;

  static platform: string;

  static version: string;

  static language: string;

  static setConfig(config: string) {
    const appConfig = JSON.parse(config);

    if (isAndroid()) {
      this.theme = get(appConfig, 'appTheme');
      this.code = get(appConfig, 'appCode');
      this.platform = get(appConfig, 'appPlatform');
      this.version = get(appConfig, 'appVersion');
      this.language = get(appConfig, 'appLanguage');
    } else {
      this.theme = get(appConfig, 'app_theme');
      this.code = get(appConfig, 'app_code');
      this.platform = get(appConfig, 'app_platform');
      this.version = get(appConfig, 'app_version');
      this.language = get(appConfig, 'app_language');
    }
  }
}
